import * as form from '../form';

export const substanceAlcoholNegative = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Occurred: form.datecontrol(xitem.Occurred),
        Circumstances: form.textarea(xitem.Circumstances),
        NegativeImpact: form.textarea(xitem.NegativeImpact),
        Used: form.daterange(xitem.Used),
        Comments: form.textarea(xitem.Comments),
      },
    };
  });
  return {
    HasImpacts: form.branch(data.HasImpacts),
    List: form.collection(items, (data.List || {}).branch),
    Comments: form.textarea(data.Comments),
    SummaryComments: form.textarea(data.SummaryComments),
    Impact: form.textarea(data.Impact), // PVQ Only
    WhenAffected: form.daterange(data.WhenAffected), // PVQ Only
  };
};
